module.exports = __webpack_public_path__ + "img/tv_screen.60638c74.png";